var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.181,
    height: 75.181,
    viewBox: "0 0 75.181 75.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2597",
    "data-name": "Groupe 2597",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_googleg_48dp",
    transform: "translate(16.072 16.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M20.337,4.333A24.342,24.342,0,0,0,19.952,0H0V8.195H11.4a9.745,9.745,0,0,1-4.227,6.394V19.9H14.02c4.006-3.688,6.317-9.119,6.317-15.571Z",
    transform: "translate(21.184 17.333)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M18.931,17.159a20.225,20.225,0,0,0,14.02-5.132L26.105,6.712a12.733,12.733,0,0,1-7.174,2.022A12.625,12.625,0,0,1,7.078,0H0V5.489A21.176,21.176,0,0,0,18.931,17.159Z",
    transform: "translate(2.253 25.21)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M9.331,13.539a12.524,12.524,0,0,1,0-8.05V0H2.253a21.211,21.211,0,0,0,0,19.028l7.078-5.489Z",
    transform: "translate(0 11.671)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M18.931,8.426a11.444,11.444,0,0,1,8.1,3.168l6.076-6.076A20.359,20.359,0,0,0,18.931,0,21.176,21.176,0,0,0,0,11.671l7.078,5.489A12.625,12.625,0,0,1,18.931,8.426Z",
    transform: "translate(2.253)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M0,0H42.369V42.369H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2907",
    "data-name": "Trac\\xE9 2907",
    d: "M74.181,37.091A37.09,37.09,0,1,1,37.09,0a37.09,37.09,0,0,1,37.09,37.09",
    transform: "translate(0 -0.001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.eeeccae90f03c1bce5c6f2b639f2b54d.svg";
export { ForwardRef as ReactComponent };